/**
 * BrandsCTA.tsx — Gold Garage Door / Brands · Section 8/8
 * Deep navy · final conversion · phone + WhatsApp + quote · GG monogram watermark.
 * WhatsApp button text MUST be navy (#081438) on green — never white.
 * MOBILE: real <style> media query for padding.
 * 10WEB AI: keep inline SVG + <style>. Wave divider at top intentional — do NOT strip.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";

/** phone — DO NOT REPLACE WITH IMG */
const IconPhone = () => <svg data-icon-container="lucide-do-not-replace" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={NAVY} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>;
/** whatsapp — DO NOT REPLACE WITH IMG */
const IconWhats = () => <svg data-icon-container="lucide-do-not-replace" width="20" height="20" viewBox="0 0 24 24" fill={NAVY}><path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.51 5.26l-.999 3.648 3.978-1.207zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z" /></svg>;
export default function BrandsCTA() {
  return <section id="contact-us" style={{
    background: `radial-gradient(ellipse at 50% 0%, #14254d 0%, ${NAVY} 60%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`
        @media (max-width: 560px){ #contact-us{ padding-top: 3.5rem; padding-bottom: 3.5rem; } }
        .bcta-actions { display: flex; gap: 1rem; justify-content: center; flex-wrap: wrap; }
        .bcta-trust { display: flex; gap: 2rem; justify-content: center; flex-wrap: wrap; }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}><filter id="grain-bcta"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter><rect width="100%" height="100%" filter="url(#grain-bcta)" /></svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      left: "50%",
      top: "55%",
      transform: "translate(-50%,-50%)",
      fontSize: "20rem",
      fontWeight: 900,
      color: `${GOLD}0A`,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      lineHeight: 1,
      userSelect: "none",
      pointerEvents: "none"
    }}>GG</div>

      <div style={{
      maxWidth: "760px",
      margin: "0 auto",
      padding: "0 1.5rem",
      textAlign: "center",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.5rem",
        background: `${GOLD}18`,
        border: `1px solid ${GOLD}40`,
        borderRadius: "9999px",
        padding: "0.375rem 1rem",
        marginBottom: "1.5rem"
      }}>
          <span style={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          background: GOLD
        }} />
          <span style={{
          color: GOLD,
          fontSize: "0.7rem",
          fontWeight: 700,
          letterSpacing: "0.12em",
          fontFamily: "'Manrope', sans-serif"
        }}>EVERY BRAND · EVERY SUBURB · SINCE 2009</span>
        </div>

        <h2 style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontWeight: 800,
        fontSize: "clamp(1.8rem, 7vw, 3rem)",
        color: "#fff",
        lineHeight: 1.12,
        marginBottom: "1rem"
      }}>
          Whatever's on your garage — <span style={{
          color: GOLD
        }}>we've got it</span>
        </h2>
        <p style={{
        fontFamily: "'Manrope', sans-serif",
        fontSize: "1.05rem",
        color: "rgba(255,255,255,0.75)",
        lineHeight: 1.7,
        marginBottom: "2.25rem",
        maxWidth: "540px",
        marginLeft: "auto",
        marginRight: "auto"
      }}>
          B&D, Merlin, ATA or anything else — one call gets the right parts and the
          right expertise to your driveway. Fixed-price quotes, 1-Year Labour Warranty.
        </p>

        <div className="bcta-actions">
          <a href="tel:0485000933" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.6rem",
          padding: "1rem 2rem",
          background: `linear-gradient(135deg, ${GOLD}, #d4a017)`,
          color: NAVY,
          fontWeight: 800,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          borderRadius: "10px",
          textDecoration: "none",
          fontSize: "1.05rem",
          boxShadow: `0 6px 26px ${GOLD}40`
        }}>
            <IconPhone /> 0485 000 933
          </a>
          <a href="https://wa.me/61485000933?text=Hi%20Gold%20Garage%20Door%2C%20I%20need%20help%20with%20my%20garage%20door%20brand" target="_blank" rel="noopener noreferrer" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.6rem",
          padding: "1rem 2rem",
          background: "#25D366",
          color: NAVY,
          fontWeight: 800,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          borderRadius: "10px",
          textDecoration: "none",
          fontSize: "1.05rem",
          boxShadow: "0 6px 26px rgba(37,211,102,0.35)"
        }}>
            <IconWhats /> WhatsApp us
          </a>
        </div>

        <div style={{
        marginTop: "1.25rem"
      }}>
          <a href="#contact-us" style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.92rem",
          color: "rgba(255,255,255,0.6)",
          textDecoration: "underline",
          textUnderlineOffset: "3px"
        }}>…or request a free written quote online</a>
        </div>

        <div className="bcta-trust" style={{
        marginTop: "2.75rem",
        borderTop: "1px solid rgba(255,255,255,0.1)",
        paddingTop: "1.75rem"
      }}>
          {[{
          n: "12+",
          l: "Brands"
        }, {
          n: "1 Yr+",
          l: "Warranty"
        }, {
          n: "217+",
          l: "Suburbs"
        }, {
          n: "5.0★",
          l: "Rating"
        }].map((s, i) => <div key={i}>
              <div style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 800,
            fontSize: "1.4rem",
            color: GOLD,
            lineHeight: 1
          }}>{s.n}</div>
              <div style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: "0.72rem",
            color: "rgba(255,255,255,0.5)",
            marginTop: "0.25rem",
            textTransform: "uppercase",
            letterSpacing: "0.08em"
          }}>{s.l}</div>
            </div>)}
        </div>
      </div>
    </section>;
}